/* ==========================================================================
   Casemira, GUIDE DES TAILLES EN TIROIR, FICHES COULOIR       C3, 05/09/2026
   --------------------------------------------------------------------------
   DIRECTION : AUDIT-COULOIR.md § 8. Ce fichier ne fait que trois choses :
   ouvrir et fermer un panneau hors flux, dessiner une scene a l'echelle de la
   selection courante, et proposer une longueur au picker.

   D'OU VIENT LA SELECTION (§ 8.1). De l'ETAT DOM du picker :
   `#casemira-couloir-picker[data-cm-largeur]` (entier, cm) et
   `[data-cm-longueur]` (deux decimales, metres, point decimal). C'est la seule
   source de verite : elle est lisible A N'IMPORTE QUEL INSTANT, y compris a
   l'ouverture du tiroir, ce qu'un evenement ne permet pas. L'evenement
   `couloir:variant-change` sert uniquement de reveil, et seulement tant que le
   tiroir est ouvert : ferme, ce fichier n'ecoute rien.

   CE QU'IL RENVOIE (§ 8.1, contrat strict). `couloir:set-dimensions` avec
   TOUJOURS LES DEUX CLES : `width` en centimetres, relue dans
   `data-cm-largeur` et jamais devinee, `length` en metres decimaux. Un
   payload partiel obligerait le picker a inventer une valeur de repli. Le
   picker accroche ensuite chaque valeur a ce qui existe reellement dans la
   matrice : ce fichier n'a donc jamais a verifier la grille avant d'emettre,
   et il RELIT l'etat DOM apres l'emission pour afficher la longueur
   reellement retenue, pas celle qu'il a demandee.

   TROIS PARTIS PRIS D'IMPLEMENTATION, ET LEURS RAISONS

   1. LE TIROIR EST DEPLACE SOUS `<body>` A LA PREMIERE OUVERTURE. Il est
      ecrit par Liquid dans le snippet du picker, donc a l'interieur de
      `<product-info>` et de la colonne d'achat. Un seul ancetre portant
      `transform`, `filter`, `perspective` ou `contain: paint` suffirait a
      faire de lui le bloc conteneur d'un enfant `position: fixed`, et le
      panneau se retrouverait colle a la colonne au lieu de la fenetre. Le
      deplacement rend le calage independant de tout ce que les autres
      chantiers feront de cette colonne. Il est gratuit : l'element est
      `hidden` (donc hors rendu) jusqu'a cet instant.
   2. LA SCENE EST DESSINEE PAR CE FICHIER, PAS PAR LIQUID. Le tiroir ne
      s'ouvre que par un geste, donc apres le JS, et son contenu est hors flux :
      aucune hauteur de PAGE n'en depend, a aucun moment. Ecrire la geometrie
      des deux scenes en Liquid dupliquerait la trigonometrie pour un premier
      octet que personne ne regarde.
   3. LES COTES SONT DES ELEMENTS HTML POSES EN POURCENTAGE PAR-DESSUS LE SVG.
      Un `<text>` dans le SVG suit l'echelle de la boite : dans le panneau de
      telephone il tomberait a 9 px, sous le plancher de 12 px de DESIGN.md
      (regle du Plancher qui Vend). C'est le meme arbitrage que le picker.

   VERROU DE DEFILEMENT : `overflow` sur la racine et la largeur de la barre
   compensee, JAMAIS `position: fixed` sur `body` (le vieux modal le fait, et
   il perd la position de lecture). La largeur est mesuree au demarrage et au
   redimensionnement, jamais sur le chemin du clic : une lecture de
   `clientWidth` juste apres avoir pose la classe force un recalcul de mise en
   page du document entier avant de rendre la main.
   ========================================================================== */
(function () {
  'use strict';

  var racine = document.documentElement;

  /* DEUX MODES, UN SEUL MOTEUR (G14). `demarre()` sert le TIROIR des 154
     fiches a matrice (une instance, panneau hors flux, longueur APPLIQUEE au
     configurateur par `couloir:set-dimensions`) et le MODE PAGE de
     /pages/guide-des-tailles (une instance par cas, rendu a plat, la longueur
     calculee devient le schema et le `?longueur=` du bouton). Quatre branches
     `PAGE`, ecrites la ou la difference se produit. LE RAISONNEMENT COMPLET
     vit dans l'en-tete Liquid de `sections/cm-guide-tailles.liquid` et de
     `snippets/cm-guide-page-calc.liquid` : un commentaire Liquid est retire au
     rendu, celui-ci part sur le reseau. L'INDENTATION DU CORPS NE BOUGE PAS :
     `g63-escalier.mjs` rejoue ce fichier tel quel. */
  function demarre(root, MODE) {
  var PAGE = (MODE === 'page');
  /* R1, 05/09 : DEUX RACINES POSSIBLES, UN SEUL CONTRAT. Le picker de la nuit
     a ete repris (decision du proprietaire), et les deux gabarits rendent de
     nouveau `couloir-calculator`. Ce fichier ne lit pas un COMPOSANT, il lit
     un ETAT : les quatre attributs `data-cm-*` du § 8.1 plus `data-matrix`,
     que le configurateur porte desormais lui aussi sur sa racine. Nommer les
     deux racines ici, dans l'ordre, coute une ligne et rend le tiroir
     indifferent a celui des deux qui est en ligne. */
  /* MODE PAGE : il n'y a pas de configurateur sur la page guide. `picker` reste
     nul, et les trois seules fonctions qui le lisent (`selection`, `plafond`,
     `applique`) ont leur branche ou leur garde. */
  var picker = PAGE ? null
    : (document.getElementById('casemira-couloir-picker')
       || document.getElementById('couloir-calculator')
       /* 25/09/2026 : le configurateur des berbères couloir et escalier porte
          le MÊME contrat (`data-cm-largeur` en cm, `data-cm-longueur` en
          mètres), plus `data-cm-sur-mesure` : pas de grille, voir `vendable`. */
       || document.getElementById('berbere-config'));
  var SUR_MESURE = !!(picker && picker.hasAttribute('data-cm-sur-mesure'));
  var panneau = root.querySelector('.cmg-panneau');
  var croix = root.querySelector('.cmg-croix');
  var boite = root.querySelector('[data-cmg-scene]');
  var elSel = root.querySelector('[data-cmg-sel]');
  var elRes = root.querySelector('[data-cmg-res]');
  var btnApp = root.querySelector('[data-cmg-appliquer]');
  /* G6.3, escalier seulement : la valeur en grand, la phrase qui l'explique,
     et le stepper (la valeur porte l'etat dans `data-n`, les deux boutons le
     font varier d'une marche). Aucun de ces quatre elements n'existe en
     couloir ni en cuisine : chaque lecture est gardee. */
  var elVal = root.querySelector('[data-cmg-val]');
  /* G17b : la ligne « dont X cm de marge de pose », sous la valeur en grand.
     Elle vit DANS le meme bloc que la reponse : le chiffre annonce et la part
     qui vient de la marge se lisent d'un seul regard, sans que le visiteur ait
     a soustraire quoi que ce soit. */
  var elMarge = root.querySelector('[data-cmg-marge]');
  var elPhrase = root.querySelector('[data-cmg-phrase]');
  var elMarches = root.querySelector('[data-cmg-marches]');
  var btnMoins = root.querySelector('[data-cmg-moins]');
  var btnPlus = root.querySelector('[data-cmg-plus]');

  /* DEUX COMPORTEMENTS, TROIS CAS. `data-cm-cas` vaut « couloir », « escalier »
     ou « cuisine » depuis le 05/09, mais ce fichier n'en connait toujours que
     deux : l'escalier a un calculateur de marches, tout le reste a un champ de
     longueur. La cuisine est donc « couloir » ici, a l'octet pres, et rien de
     ce qui suit ne la distingue SAUF un libelle du detail de largeur. Ecrire la
     ternaire ainsi, plutot que de lister les cas, garantit qu'un quatrieme cas
     ajoute demain en Liquid heritera du meme comportement sans toucher au JS. */
  var CAS = root.getAttribute('data-cm-cas') === 'escalier' ? 'escalier' : 'couloir';
  var CUISINE = root.getAttribute('data-cm-cas') === 'cuisine';
  var SEP = root.getAttribute('data-sep') || ',';
  var MARGE = Number(root.getAttribute('data-marge')) || 5; /* centimetres */

  var T = {
    bord: root.getAttribute('data-t-bord') || '',
    coteLongueur: root.getAttribute('data-t-cote-longueur') || '',
    coteLargeur: root.getAttribute('data-t-cote-largeur') || '',
    sceneCouloir: root.getAttribute('data-t-scene-couloir') || '',
    sceneEscalier: root.getAttribute('data-t-scene-escalier') || '',
    legendeMarche: root.getAttribute('data-t-legende-marche') || '',
    legendePlate: root.getAttribute('data-t-legende-plate') || '',
    legendeVerticale: root.getAttribute('data-t-legende-verticale') || '',
    phraseEscalier: root.getAttribute('data-t-phrase-escalier') || '',
    /* G18a, 08/09 : UN SEUL GABARIT DE MARGE. `margeArrondi`, et la cle
       `casemira.guide.calc_escalier_marge_arrondi` qui le remplissait, sont
       retires (registre `.impeccable/tools/i18n-cles-supprimees.txt`) : la
       ligne ne dit plus que la marge de pose, l'arrondi au format vendu reste
       applique en silence. */
    margeEscalier: root.getAttribute('data-t-marge-escalier') || '',
    marche: root.getAttribute('data-t-marche') || '',
    marches: root.getAttribute('data-t-marches') || '',
    regle: root.getAttribute('data-t-regle') || '',
    marchesFew: root.getAttribute('data-t-marches-few') || '',
    marchesDe: root.getAttribute('data-t-marches-de') || '',
    marchesTwo: root.getAttribute('data-t-marches-two') || '',
    resCouloir: root.getAttribute('data-t-res-couloir') || '',
    applique: root.getAttribute('data-t-applique') || '',
    notePlafond: root.getAttribute('data-t-note-plafond') || '',
    /* S3, 06/10 : la phrase du configurateur quand le bout atteint est celui
       du STOCK et non celui de la grille (jeton `[max]`). */
    maxDispoDepasse: root.getAttribute('data-t-max-dispo-depasse') || '',
    noteProche: root.getAttribute('data-t-note-proche') || '',
    contact: root.getAttribute('data-t-contact') || ''
  };

  /* La ligne de resultat porte au plus DEUX voix : le resultat, en corps, et
     la note qui l'explique, en dessous et en Encre Estompee. Tout ecrire d'un
     seul trait ferait un pave de trois lignes en 16 px demi-gras, ou la
     valeur, qui est la seule chose que le visiteur cherche, se perdrait. */
  function poseResultat(principal, note, avecContact) {
    if (!elRes) return;
    elRes.textContent = principal || '';
    if (!note) return;
    var sp = document.createElement('span');
    sp.className = 'cmg-res__note';
    sp.textContent = note;
    /* S3, 06/10 : MODE « phrase ». La note est une phrase complete (« ... jusqu'a
       6,00 m »), sans deux-points d'attente : on la ferme par un point et le
       lien contact devient la phrase suivante, majuscule initiale comprise
       (« Ecrivez-nous. »). Sans lien, la phrase seule, fermee par son point. */
    if (avecContact === 'phrase') {
      sp.textContent = note.replace(/[\s.]+$/, '') + '.';
      var u2 = root.getAttribute('data-contact');
      if (u2 && T.contact) {
        var a2 = document.createElement('a');
        a2.setAttribute('href', u2);
        a2.textContent = T.contact.charAt(0).toUpperCase() + T.contact.slice(1);
        sp.appendChild(document.createTextNode(' '));
        sp.appendChild(a2);
        sp.appendChild(document.createTextNode('.'));
      }
      elRes.appendChild(sp);
      return;
    }
    if (avecContact) {
      var u = root.getAttribute('data-contact');
      if (u && T.contact) {
        /* Le lien est construit en DOM, jamais en `innerHTML` : l'adresse vient
           de `cm-url` en Liquid, le libelle d'une cle de locale, et rien de ce
           qui est ecrit ici ne peut devenir du balisage. */
        var a = document.createElement('a');
        a.setAttribute('href', u);
        a.textContent = T.contact;
        sp.appendChild(document.createTextNode(' '));
        sp.appendChild(a);
        /* Le point ferme la phrase que le texte laisse ouverte sur son
           deux-points. Il est pose EN DEHORS du `<a>` : dans le libelle, un
           lecteur d'ecran le lirait avec le lien. */
        sp.appendChild(document.createTextNode('.'));
      } else {
        /* PAS DE LIEN, PAS DE DEUX-POINTS SUSPENDU. Ajouter un point derriere
           donnerait « c'est possible :. ». On REMPLACE la ponctuation
           d'attente par le point final : la phrase se termine proprement, avec
           ou sans lien, et c'est le meme texte de locale dans les deux cas. */
        sp.textContent = note.replace(/\s*:\s*$/, '.');
      }
    }
    elRes.appendChild(sp);
  }

  /* ── Petits outils ──────────────────────────────────────────────────────── */
  function tpl(chaine, jetons) {
    var s = String(chaine || '');
    for (var k in jetons) {
      if (Object.prototype.hasOwnProperty.call(jetons, k)) s = s.split(k).join(jetons[k]);
    }
    return s;
  }
  /* La virgule et le point sont acceptes a la saisie dans les quatre langues :
     un clavier de telephone allemand ne propose pas le meme separateur qu'un
     clavier anglais, et refuser l'un des deux serait refuser la moitie des
     saisies. */
  function nombre(el) {
    if (!el) return NaN;
    return parseFloat(String(el.value).replace(',', '.').replace(/[^0-9.]/g, ''));
  }
  function metres(v) { return v.toFixed(2).replace('.', SEP); }
  function pct(v, total) { return (v / total * 100).toFixed(3) + '%'; }

  /* ── L'etat DOM du picker, seule source de verite ───────────────────────── */
  function selection() {
    /* MODE PAGE : LA SOURCE EST LA MEME, ELLE EST SIMPLEMENT AILLEURS. L'hote
       porte les deux memes attributs, ecrits par Liquid au premier octet (80 cm
       de large, la largeur de toute la collection couloir ; 3,00 m de long) et
       reecrits par `majPage()` a chaque saisie : le dessin suit le champ sans
       qu'aucune autre ligne de ce fichier ait a le savoir. */
    var src = PAGE ? root : picker;
    if (!src) return null;
    var w = Number(src.getAttribute('data-cm-largeur'));
    var l = Number(src.getAttribute('data-cm-longueur'));
    if (!isFinite(w) || w <= 0 || !isFinite(l) || l <= 0) return null;
    return { w: w, l: l };
  }

  /* ── La scene ───────────────────────────────────────────────────────────── */
  /* UN SEUL DESSIN, UNE SEULE ECHELLE SUR LES DEUX AXES (retour Raph du 05/09,
     proposition 1 de la maquette G2.1). Ce qui precedait avait DEUX dessins a
     DEUX echelles : la vue de dessus, puis une bande « detail de largeur » qui
     redessinait la MEME largeur, a l'horizontale, a une echelle ou 80 cm
     remplissaient toute la boite. La largeur y occupait donc plus de place que
     la longueur juste au-dessus, et le rapport reel disparaissait. La bande est
     supprimee du cas couloir (et du cas cuisine, qui reprend la meme scene).

     Elle a SUBSISTE pour l'escalier jusqu'a G6.3, en vue de face : la vue de
     profil ne montrait pas la largeur du tapis. Elle est partie avec les champs
     de profondeur et de hauteur (retour Raph du 06/09 18h21) ; la largeur reste
     dite en toutes lettres par la ligne « Votre selection » et par le repere
     des 5 cm. L'escalier n'a donc plus qu'un dessin, dans la meme boite 2/1 que
     le couloir.

     L'ECHELLE DU COULOIR EST FIXE, avec une longueur de reference de 4 m :
     a 2 m le tapis occupe la moitie du cadre, a 4 m tout le cadre, au-dela il
     reste plein cadre et c'est la LARGEUR qui retrecit, au rapport exact. Une
     echelle recalculee a chaque format, ce que faisait le dessin precedent,
     donne toujours la meme image : le format ne se voit plus, et un 80 x 2,00 m
     s'y dessinait presque comme un 80 x 6,00 m.

     LA BOITE NE BOUGE JAMAIS, ET DEPUIS G6.3 ELLE EST LA MEME POUR LES TROIS
     CAS : 2/1, dans la feuille de style comme ici. L'escalier tenait un 4/3
     parce qu'il empilait deux vues ; il n'en a plus qu'une. Le repere de dessin
     est ecrit avec EXACTEMENT le meme rapport que la boite : sans quoi le
     `preserveAspectRatio` laisserait des bandes vides et les etiquettes, posees
     en pourcentage de la boite, ne tomberaient plus sur leurs traits. Ces deux
     constantes et cette regle de trois sont donc la meme decision, ecrite deux
     fois : elles se lisent ensemble. */
  var VW = 400;           /* largeur du repere de dessin, les trois cas */
  var VH = 200;           /* 2/1, les trois cas */
  var REF_CM = 400;       /* longueur de reference de l'echelle, centimetres */
  /* LE JEU EST DESSINE EN UNITES DE REPERE, PAS A L'ECHELLE, et c'est la seule
     licence du dessin. 5 cm a l'echelle valent 3,6 unites sur 400 a 4 m et 1,4
     a 10 m : trace au millimetre, le tapis toucherait les murs et le dessin
     dirait le contraire de la phrase. 7 unites font 7 px de sol visible au 1440
     et 6 px au 390. La cote « 5 cm » dit la valeur, le dessin dit qu'il y a un
     ecart : on grossit ce qu'on nomme, on ne deforme jamais l'objet. */
  var JEU_U = 7;

  function svgEl(nom, attrs) {
    var s = '<' + nom;
    for (var k in attrs) {
      if (Object.prototype.hasOwnProperty.call(attrs, k)) s += ' ' + k + '="' + attrs[k] + '"';
    }
    return s + '></' + nom + '>';
  }

  function dessine() {
    noteAdresse();
    if (!boite) return;
    var sel = selection();
    if (!sel) return;

    var escalier = CAS === 'escalier';

    var corps = [];
    var etiquettes = [];
    var aria = '';

    if (escalier) {
      /* Le dessin ne depend QUE de ce qu'une marche coute en tapis : il ne
         bouge pas quand le nombre de marches change (voir `vueEscalier`). */
      var p = marches();
      vueEscalier(p.g + p.c, corps, etiquettes);
      aria = T.sceneEscalier;
    } else {
      vueCouloir(VW, VH, sel, corps, etiquettes);
      aria = tpl(T.sceneCouloir, { '[w]': String(sel.w), '[l]': metres(sel.l) });
    }

    /* Aucun attribut `width` ni `height` en pixels sur le SVG, et un
       `preserveAspectRatio` explicite : c'est la correction directe du defaut
       de `render()` (`casemira-cm-size-guide.js` l.105), qui recalait la boite
       a chaque changement de format. */
    var html = '<svg class="cmg-svg" viewBox="0 0 ' + VW + ' ' + VH + '" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">'
      + corps.join('')
      + '</svg>';
    boite.innerHTML = html;

    for (var i = 0; i < etiquettes.length; i++) {
      var e = etiquettes[i];
      var sp = document.createElement('span');
      sp.className = 'cmg-lab'
        + (e.muet ? ' cmg-lab--muet' : '')
        + (e.fort ? ' cmg-lab--fort' : '')
        + (e.vert ? ' cmg-lab--vert' : '')
        + (e.or ? ' cmg-lab--or' : '');
      sp.style.left = pct(e.x, VW);
      sp.style.top = pct(e.y, VH);
      sp.textContent = e.t;
      boite.appendChild(sp);
    }

    /* LA LEGENDE DU POINTILLE N'EST PAS ICI, ET C'EST VOULU (revue G3.1). Elle
       a d'abord ete posee DANS cette boite, qui porte `role="img"` : tout ce
       qu'elle contient devient alors invisible pour un lecteur d'ecran, qui ne
       lit que l'`aria-label`. La phrase qui nomme les 5 cm n'aurait jamais ete
       annoncee. Elle est donc ecrite par Liquid, en flux, en FRERE de la boite
       (voir le snippet) : elle se lit, elle s'enroule sur deux lignes a 320 px
       sans monter dans la cote de longueur, et elle est la au premier octet,
       donc sans decalage. */
    boite.setAttribute('aria-label', aria);

    if (elSel) elSel.textContent = sel.w + ' cm × ' + metres(sel.l) + ' m';
  }

  /* Vue de dessus, cas couloir et cas cuisine : LE TAPIS DANS SON COULOIR.

     Retour de Raph, 06/09 01h43 : « on ne comprend pas trop ton truc de
     pointille, les pointilles ca represente le couloir ? C'est pas clair.
     5 cm de jeu de chaque cote, mais entre quoi ? » Le pointille demandait au
     lecteur de deviner ce qu'il bordait, et un trait ne repond pas a « entre
     quoi ». Il est remplace par le decor, celui de la proposition 2 de la
     maquette G2.1 SANS la porte : deux murs hachures le long de la longueur,
     un seuil leger a chaque extremite, le tapis pose entre les quatre. Le jeu
     n'est plus a interpreter, c'est un ecart qui se voit.

     LE CADRAGE EST CELUI D'UN PLAN : tout ce qui n'est pas le sol du couloir
     est du mur, hachure, jusqu'au bord de la boite. Trois surfaces, toutes du
     systeme : Papier pour le sol, Filet Appuye pour le mur, Sable pour le
     tapis. Aucune quatrieme couleur inventee pour faire joli.

     LE TAPIS RESTE A L'ECHELLE. Le rapport largeur / longueur du rectangle est
     exact, l'echelle reste FIXE (reference 4 m) : tout ce que G3.1 a etabli
     tient, et le decor ne s'y substitue pas, il l'entoure. Seul le jeu est
     grossi, a valeur constante (`JEU_U`), et c'est la petite cote « 5 cm » qui
     le chiffre.

     UNE SEULE COTE DE JEU, ET A L'EXTREMITE. Le conseil porte sur la longueur
     (« prevoyez 5 cm de jeu a chaque extremite ») : la cote est posee la ou le
     conseil s'applique, entre le bout du tapis et le seuil de droite. Elle est
     en Encre Estompee et sans demi-gras, pour que les deux cotes que le
     visiteur est venu lire restent les seules a porter du poids. */
  function vueCouloir(VW, VH, sel, corps, etiquettes) {
    /* 56 unites a gauche : la cote de largeur, son amorce et le libelle tourne.
       46 a droite : la cote de jeu et son « 5 cm », que 7 unites d'ecart ne
       peuvent pas loger. Entre les deux, l'emprise du couloir dessine. Le
       couple (padT 26, padB 37) ne sert plus qu'a poser le centre vertical, et
       c'est le meme que celui de G3.1 : le tapis reste centre sur 94,5, a la
       meme hauteur qu'avant. IL N'EST PAS A LA MEME PLACE EN LARGEUR, et il ne
       faut pas le dire autrement : le cadre utile du tapis passe de 314 a 284
       unites (30 unites de plus a droite pour la cote de jeu, 2 x 7 pour les
       jeux eux-memes), soit un tapis 9,5 % plus court a l'ecran qu'en G3.1. Le
       rapport largeur / longueur, lui, est le meme au millieme pres. */
    var padL = 56, padR = 46, padT = 26, padB = 37;
    var utile = VW - padL - padR;
    var longCm = sel.l * 100;

    /* Le cadre utile loge LE COULOIR, pas le tapis seul : les deux jeux
       prennent leur part avant que l'echelle ne soit calculee, sans quoi le
       decor deborderait de la boite. */
    var s = (utile - 2 * JEU_U) / Math.max(longCm, REF_CM);
    var rw = longCm * s;
    var rh = sel.w * s;
    var cx = padL + utile / 2;
    var cy = padT + (VH - padT - padB) / 2;
    var x0 = cx - rw / 2, x1 = cx + rw / 2;
    var y0 = cy - rh / 2, y1 = cy + rh / 2;
    var ci0 = y0 - JEU_U, ci1 = y1 + JEU_U;  /* faces interieures des deux murs */
    var xs0 = x0 - JEU_U, xs1 = x1 + JEU_U;  /* les deux seuils */

    /* Le mur, sa hachure, puis le sol par-dessus : trois formes dans cet ordre,
       et la hachure ne deborde jamais sur le sol. */
    corps.push(svgEl('rect', { 'class': 'cmg-mur', x: 0, y: 0, width: VW, height: VH }));
    var hach = '';
    for (var hx = -VH; hx < VW + VH; hx += 8) hach += 'M' + hx + ' 0l' + VH + ' ' + VH;
    corps.push('<path class="cmg-hachure" d="' + hach + '"></path>');
    corps.push(svgEl('rect', {
      'class': 'cmg-sol', x: 0, y: ci0.toFixed(1),
      width: VW, height: (ci1 - ci0).toFixed(1)
    }));
    /* LA BANDE DE JEU, TEINTEE, ET C'EST ELLE QUI REPOND A « ENTRE QUOI ? ».
       Le sol du couloir entre les deux seuils, c'est EXACTEMENT le tapis plus
       ses 5 cm : teinter ce rectangle et poser le tapis dessus laisse un anneau
       visible tout autour, sans un mot. Une cote de 6 px avec son chiffre
       rejete dans le vide ne se lisait pas ; une surface, si.
       La teinte est la Bordure et non le Sable : le Sable est a 3 % du Papier,
       il ne se verrait pas sur le sol, et c'est deja la couleur du tapis. */
    corps.push(svgEl('rect', {
      'class': 'cmg-bande', x: xs0.toFixed(1), y: ci0.toFixed(1),
      width: (xs1 - xs0).toFixed(1), height: (ci1 - ci0).toFixed(1)
    }));
    corps.push('<path class="cmg-plinthe" d="M0 ' + ci0.toFixed(1) + 'H' + VW
      + 'M0 ' + ci1.toFixed(1) + 'H' + VW + '"></path>');

    /* LES DEUX EXTREMITES SONT SUGGEREES, PAS FERMEES : un seuil, dessine comme
       sur un plan, la ou le couloir passe dans autre chose. Le sol continue
       au-dela, donc le couloir est plus long que le tapis, et c'est cet ecart
       que la cote de jeu vient chiffrer. Pas de porte, pas de volee : le
       battant d'hier balayait le seul objet que le visiteur regarde. */
    corps.push(svgEl('rect', {
      'class': 'cmg-seuil', x: (xs0 - 2).toFixed(1), y: ci0.toFixed(1),
      width: 4, height: (ci1 - ci0).toFixed(1)
    }));
    corps.push(svgEl('rect', {
      'class': 'cmg-seuil', x: (xs1 - 2).toFixed(1), y: ci0.toFixed(1),
      width: 4, height: (ci1 - ci0).toFixed(1)
    }));

    corps.push(svgEl('rect', {
      'class': 'cmg-tapis',
      x: x0.toFixed(1), y: y0.toFixed(1),
      width: rw.toFixed(1), height: rh.toFixed(1), rx: 1
    }));

    /* Cote de LONGUEUR, a l'horizontale, sous la plinthe basse. Elle tombe DANS
       la hachure du mur, et c'est assume : la boite ne fait que 200 unites de
       haut, la sortir du mur aurait demande de rendre le couloir plus etroit ou
       la boite plus haute. Le trait d'encre passe sans peine sur un aplat de
       Bordure Appuyee raye de blanc, et le chiffre porte une pastille de Papier
       opaque qui lui rend son fond calme. C'est le meme geste que la cote de
       jeu, dix lignes plus bas. */
    var cyL = Math.min(ci1 + 26, VH - 20);
    corps.push('<path class="cmg-amorce" d="M' + x0.toFixed(1) + ' ' + y1.toFixed(1) + 'V' + (cyL + 6).toFixed(1)
      + 'M' + x1.toFixed(1) + ' ' + y1.toFixed(1) + 'V' + (cyL + 6).toFixed(1) + '"></path>');
    corps.push('<path class="cmg-cote" d="M' + x0.toFixed(1) + ' ' + (cyL - 5).toFixed(1) + 'V' + (cyL + 5).toFixed(1)
      + 'M' + x0.toFixed(1) + ' ' + cyL.toFixed(1) + 'H' + x1.toFixed(1)
      + 'M' + x1.toFixed(1) + ' ' + (cyL - 5).toFixed(1) + 'V' + (cyL + 5).toFixed(1) + '"></path>');
    etiquettes.push({ x: cx, y: cyL, t: tpl(T.coteLongueur, { '[l]': metres(sel.l) }), fort: true });

    /* Cote de LARGEUR, a la verticale, a gauche du tapis. Le libelle tourne
       avec elle : convention du dessin technique, et c'est ce qui libere la
       largeur du dessin sur telephone. Elle suit le tapis (x0 - 25) au lieu de
       rester collee au bord : sur un tapis court, elle reste a cote de ce
       qu'elle mesure. */
    /* PAS D'AMORCE ICI, ET C'EST UN RETRAIT VOLONTAIRE (« on preferera retirer
       un trait »). Deux lignes horizontales tirees jusqu'au tapis traverseraient
       le seuil de gauche : trois traits paralleles a 3 px l'un de l'autre, ou
       le lecteur ne distingue plus le decor de la cote. Les deux tirets de la
       cote tombent exactement sur les bords du tapis, l'oeil fait le reste. */
    var cxW = Math.max(x0 - 25, 30);
    corps.push('<path class="cmg-cote" d="M' + (cxW - 5).toFixed(1) + ' ' + y0.toFixed(1) + 'H' + (cxW + 5).toFixed(1)
      + 'M' + cxW.toFixed(1) + ' ' + y0.toFixed(1) + 'V' + y1.toFixed(1)
      + 'M' + (cxW - 5).toFixed(1) + ' ' + y1.toFixed(1) + 'H' + (cxW + 5).toFixed(1) + '"></path>');
    etiquettes.push({ x: cxW - 16, y: cy, t: tpl(T.coteLargeur, { '[w]': String(sel.w) }), fort: true, vert: true });

    /* LA COTE DE JEU, une seule et discrete, CONTRE LA PLINTHE : c'est la que
       l'oeil cherche la reponse a « 5 cm entre quoi ? », entre le bord du tapis
       et le mur, et c'est ce que la legende sous le dessin dit avec des mots.
       Posee au bout du tapis, contre le seuil, elle chiffrait la meme valeur au
       mauvais endroit et son « 5 cm » partait dans le vide.
       Elle est verticale, tiree a 78 % de la longueur du tapis : assez loin de
       la cote de largeur pour ne pas la rencontrer, assez loin du bord droit
       pour que son chiffre tienne. Le chiffre monte au-dessus de la plinthe,
       sur la hachure : sa pastille de Papier le detache, et la bande teintee
       en dessous dit deja de quel ecart il parle. */
    var xJ = x0 + rw * 0.78;
    corps.push('<path class="cmg-cote cmg-cote--jeu" d="M' + (xJ - 4).toFixed(1) + ' ' + y0.toFixed(1) + 'H' + (xJ + 4).toFixed(1)
      + 'M' + xJ.toFixed(1) + ' ' + y0.toFixed(1) + 'V' + (ci0 - 8).toFixed(1)
      + 'M' + (xJ - 4).toFixed(1) + ' ' + ci0.toFixed(1) + 'H' + (xJ + 4).toFixed(1) + '"></path>');
    etiquettes.push({ x: xJ, y: Math.max(ci0 - 16, 10), t: MARGE + ' cm', muet: true });

    /* EN CUISINE, LE TAPIS N'EST PAS ENTRE DEUX MURS : il est devant les
       meubles. La scene est la meme au trait pres ; seul ce libelle, pose sur
       la bande du haut, dit de quoi elle est faite (`data-t-bord`, ecrit par
       Liquid pour ce seul cas).
       IL EST TIRE VERS LA GAUCHE, et pas centre : il partage cette bande avec
       le chiffre du jeu, qui est a 78 % de la longueur. Centre, il le
       rencontrait des 2 m (« Devant les meubles » fait 120 unites de large a
       lui seul). La borne a 80 unites de xJ tient les deux a l'ecart quelle que
       soit la longueur, et le plancher a 62 garde le libelle dans la boite. */
    if (CUISINE && T.bord) {
      etiquettes.push({
        x: Math.max(Math.min(x0 + rw * 0.25, xJ - 80), 62),
        y: Math.max(ci0 / 2, 12), t: T.bord, muet: true
      });
    }

    return { x0: x0, x1: x1, y0: y0, y1: y1, rw: rw, rh: rh, s: s };
  }

  /* ── LE DESSIN DE L'ESCALIER (G6.3) ──────────────────────────────────────
     Retour de Raph (06/09 18h21) : « escalier : pas clair ce que veut dire la
     profondeur d'une marche, la partie horizontale et verticale ; il faut que
     ca soit plus explicite, que ca parle a tout le monde, trop d'expertise. »

     CE QUE CE DESSIN NE FAIT PLUS : representer l'escalier du visiteur. Il
     dessinait ses N marches a l'echelle, avec le tapis arrete pile ou la
     longueur choisie s'arretait, et une vue de face dessous pour la largeur.
     Trois inconnues a lire d'un coup, et un dessin qui changeait a chaque
     appui sur un bouton.

     CE QU'IL FAIT : il montre D'OU VIENT LE CHIFFRE. Quatre marches de profil,
     le tapis en un seul trait d'encre pose dessus, et la PREMIERE marche
     surlignee en or avec sa seule etiquette, « environ 46 cm de tapis ». C'est
     l'unite que la phrase nomme, et c'est tout ce qu'il y a a comprendre : une
     marche coute un dessus plus une face avant.

     IL NE BOUGE PAS quand le nombre de marches change. Rien ne saute a
     l'ecran, et il n'y a rien de nouveau a relire a chaque appui. Le seul
     chiffre qui l'atteint est le cout d'une marche, et il ne bouge que si les
     constantes du calcul bougent.

     Les valeurs sont celles de la maquette G5.7 (proposition A), portees
     telles quelles : quatre marches de 76 x 34 unites, posees a (44, 166) dans
     un repere de 400 x 200, et 34 unites de palier apres la derniere. */
  var ESC = { d: 76, h: 34, x0: 44, y0: 166, n: 4, palier: 34 };
  function vueEscalier(parMarche, corps, etiquettes) {
    var d = ESC.d, h = ESC.h, x0 = ESC.x0, y0 = ESC.y0;
    var i;
    var profil = 'M' + x0 + ' ' + y0;
    for (i = 0; i < ESC.n; i++) profil += 'h' + d + 'v' + (-h);
    profil += 'h' + ESC.palier;
    corps.push('<path class="cmg-marche" d="' + profil + '"></path>');

    /* Le tapis est le seul trait plein du dessin : c'est le produit, il porte
       l'encre. Il couvre les quatre marches dessinees, pas le palier. */
    var drape = 'M' + x0 + ' ' + y0;
    for (i = 0; i < ESC.n; i++) drape += 'h' + d + 'v' + (-h);
    corps.push('<path class="cmg-drape" d="' + drape + '"></path>');

    /* PAS DE TRAIT POUR LA MARGE, ET C'EST UN RETRAIT ASSUME (fix round de la
       revue G17b). Le dessin prolongeait le tapis sur le palier en pointille,
       pour dire « ca continue un peu ». Au 390, ce prolongement se reduit a
       quatre points gris de deux pixels dans un coin du cadre : personne ne le
       lit comme une marge, et un trait qu'il faut expliquer ne remplit pas son
       office. La marge est dite en toutes lettres deux centimetres plus bas,
       avec ses deux nombres et leur origine ; c'est la que le visiteur la lit.
       Regle « on preferera retirer un trait » (DESIGN.md). */

    /* L'unite, par-dessus le tapis : la partie plate de la premiere marche et
       sa partie verticale, en or bruni. Une seule etiquette EN OR dans tout le
       dessin : celle qui porte le chiffre. */
    corps.push('<path class="cmg-unite" d="M' + x0 + ' ' + y0 + 'h' + d + 'v' + (-h) + '"></path>');
    etiquettes.push({
      x: x0 + d + 4, y: y0 + 18,
      t: tpl(T.legendeMarche, { '[cm]': String(parMarche) }), or: true
    });

    /* ── LES DEUX MOTS, POSES SUR LES DEUX TRAITS QU'ILS NOMMENT (G11.2) ────
       Retour de Raph du 07/09 a 02h40 : « le dessus et le devant, c'est pas
       parlant ; la partie plate et la partie verticale, je sais pas comment on
       peut mieux le faire comprendre. » La phrase sous la reponse change de
       mots ; le dessin, lui, montrait deja les deux traits sans jamais les
       nommer. Les voila nommes, en toutes lettres, chacun contre le sien : le
       mot et le trait se repondent sans fleche ni ligne de rappel, et le
       lecteur n'a plus a deviner lequel des deux vaut 28 et lequel vaut 18.

       EN ENCRE ESTOMPEE, PAS EN OR. L'or reste reserve au chiffre, qui est la
       reponse ; ces deux-la sont du vocabulaire, ils se lisent une fois et se
       taisent. Trois etiquettes en or feraient trois reponses.

       LES POSITIONS SONT LUES SUR LE TRACE, pas ecrites en dur. Regler `ESC`
       deplace donc les mots avec les traits.
         · « partie plate » se pose JUSTE AU-DESSUS du segment (x0, y0) ->
           (x0 + d, y0), un peu a gauche de son milieu : au 390 le mot fait 70 px
           et le segment 65, le centrer pile le pousserait dans le voisin.
         · « partie verticale » se pose A DROITE du segment (x0 + d, y0) ->
           (x0 + d, y0 - h), a mi-hauteur, dans le creux de la marche suivante.
           Ce creux est vide d'encre : le profil n'est qu'un trait, sans
           remplissage, et la contremarche suivante est plus haut (y0 - 2h). Le
           mot ne coupe donc aucune ligne, ce qu'une etiquette a fond papier
           ferait sans le dire.
       LES DEUX BOITES NE SE TOUCHENT PAS, au 390 comme au 1440 et dans les
       quatre langues : `g63-escalier.mjs` mesure les rectangles a l'ecran et
       refuse le moindre recouvrement. C'est la seule facon de tenir la promesse
       « le mot repond au trait » quand une traduction s'allonge. */
    etiquettes.push({ x: x0 + d * 0.35, y: y0 - 16, t: T.legendePlate, muet: true });
    etiquettes.push({ x: x0 + d + 65, y: y0 - h / 2, t: T.legendeVerticale, muet: true });
  }

  /* ── Le calculateur ─────────────────────────────────────────────────────── */
  var inCouloir = root.querySelector('[data-cmg-couloir]');
  var couloirTouche = false;
  /* MODE PAGE : « Voir les tapis couloir », ecrit par Liquid avec l'adresse de
     la collection et remis a jour a chaque longueur. Ce n'est pas
     `[data-cmg-appliquer]` : ce dernier commande le configurateur d'une fiche,
     et il n'y en a pas ici. */
  var lienPage = PAGE ? root.querySelector('[data-cmg-lien]') : null;

  /* ── CE QU'UNE MARCHE COUTE EN TAPIS, ET C'EST LA SEULE CONSTANTE A REGLER ─
     Le tiroir ne demande plus la profondeur ni la hauteur d'une marche (G6.3,
     retour Raph du 06/09 18h21). Les deux valeurs restent dans le CALCUL, ici,
     en clair : ce sont celles que les champs portaient en valeur par defaut
     depuis le premier jour, et le chiffre affiche par la fiche n'a donc pas
     bouge d'un centimetre (28 + 18 = 46 cm par marche, 13 marches = 5,98 m).

     POUR LES REGLER, ON CHANGE CES DEUX LIGNES, et rien d'autre : l'etiquette
     du dessin et le resultat lisent `MARCHE_G + MARCHE_C`, et la phrase lit
     les trois nombres (le total, puis chacune des deux depuis G9.2, parce
     qu'elle dit maintenant d'ou vient le total). Une valeur, un ecran : aucun
     de ces nombres n'est ecrit dans une cle de locale. */
  var MARCHE_G = 28;  /* la partie plate d'une marche, centimetres */
  var MARCHE_C = 18;  /* sa partie verticale, centimetres          */

  /* ── LA MARGE DE POSE (G17b, retour Raph du 07/09 a 19h45) ────────────────
     « Quand le tapis est reellement pose, plaque sur la marche, il y a
     toujours un petit gap ; mieux vaut un poil trop long, on ajuste, trop
     court c'est trop court. »

     Le calcul de G6.3 donnait la longueur GEOMETRIQUE du parcours : 46 cm par
     marche, pas un centimetre de plus. C'est juste sur le papier et faux sur
     l'escalier : un tapis plaque epouse le nez de marche, il ne tourne pas a
     angle vif, et chaque marche lui coute quelques centimetres de plus. Les
     deux extremites, elles, se rabattent et se fixent : elles coutent une
     fois.

     DEUX TERMES, ET CHACUN DIT D'OU IL VIENT :
       · 3 cm PAR MARCHE, le rayon du nez de marche ;
       · 20 cm EN TOUT, les finitions du haut et du bas.
     Soit 49 x n + 20 centimetres. Treize marches : 598 + 39 + 20 = 657 cm, que
     la grille de la boutique arrondit ensuite a 7,00 m (voir `vendable`).

     POUR LES REGLER, ON CHANGE CES DEUX LIGNES, et rien d'autre : la valeur
     affichee, la ligne « dont X cm de marge de pose » et le trait pointille du
     dessin lisent toutes les trois ces deux constantes. Aucun de ces nombres
     n'est ecrit dans une cle de locale. */
  var MARGE_MARCHE = 3;  /* centimetres par marche, le nez de marche      */
  var MARGE_BOUTS = 20;  /* centimetres en tout, les finitions haut et bas */

  /* LA GRILLE DE REPLI, quand aucune matrice n'est lisible : c'est le cas du
     MODE PAGE, qui n'a pas de configurateur a interroger, et d'une fiche dont
     le metachamp manquerait. Elle reproduit la forme de la grille reelle,
     relevee en Admin le 07/09 (lecture seule) et identique pour les sept
     largeurs : 10 cm jusqu'a 5 m, 50 cm au-dela.

     C'EST LE SEUL FAIT DUPLIQUE DE CE FICHIER, et il est ecrit ici plutot que
     devine parce que l'alternative est pire : un pas unique de 10 cm ferait
     annoncer 6,60 m par la page guide et 7,00 m par la fiche, pour le meme
     escalier de treize marches. La matrice reelle reste TOUJOURS preferee des
     qu'elle existe : ces deux lignes ne servent jamais sur une fiche. */
  var REPLI = { seuil: 5, bas: 0.10, haut: 0.50 };

  /* La seule borne qui reste : 60 marches. Elle n'a plus besoin d'etre DITE
     (`calc_borne` est partie avec les champs de saisie), parce qu'elle ne peut
     plus etre depassee : le stepper s'arrete a 1 et a 60, boutons desactives.
     Une borne qu'on ne peut pas franchir n'a pas a s'expliquer. */
  var BORNES = { n: 60 };

  /* L'ETAT DU STEPPER VIT DANS LE DOM, dans `data-n`, et pas dans une variable
     de ce fichier : Liquid ecrit la valeur de depart au premier octet (13), le
     JS la relit, et il n'y a jamais deux verites a tenir d'accord. Meme parti
     pris que la selection du picker, lue dans ses attributs. */
  function nMarches() {
    var n = elMarches ? Math.round(Number(elMarches.getAttribute('data-n'))) : NaN;
    if (!isFinite(n) || n < 1) n = 13;
    return Math.min(n, BORNES.n);
  }
  function marches() { return { g: MARCHE_G, c: MARCHE_C, n: nMarches() }; }

  /* 04/10/2026 (22h) : forme plurielle selon `casemira.pluriel.regle` (meme regle que
     snippets/cm-pluriel.liquid) : 'one' (forme de 1, croate 21, 31...), 'few' (2 a 4, cs et sk ;
     croate 22-24...), 'de' (roumain, 20 et plus et n%100 = 0), '' sinon (forme plurielle). */
  function formePluriel(n, regle) {
    var d = n % 10, c = n % 100;
    if (n === 1) return 'one';
    if (regle === '2-4') return n >= 2 && n <= 4 ? 'few' : '';
    if (regle === 'slave-sud') {
      if (d === 1 && c !== 11) return 'one';
      if (d >= 2 && d <= 4 && (c < 12 || c > 14)) return 'few';
      return '';
    }
    if (regle === 'ro') return n > 0 && (c === 0 || c >= 20) ? 'de' : '';
    if (regle === 'lv' || regle === 'lt') {
      /* letton, lituanien (06/10/2026) : 1, 21... forme de 1 ; 2-9, 22-29... few ; 0, 10-20... pluriel */
      if (c >= 11 && c <= 19) return '';
      if (d === 1) return 'one';
      if (d >= 2) return 'few';
      return '';
    }
    if (regle === 'sl') {
      /* 06/10/2026, slovene : 1, 101... forme de 1 ; 2, 102... duel ; 3-4, 103-104... few */
      if (c === 1) return 'one';
      if (c === 2) return 'two';
      if (c === 3 || c === 4) return 'few';
      return '';
    }
    return '';
  }
  function uniteMarches(n) {
    if (n <= 1) return T.marche;
    var f = formePluriel(n, T.regle);
    if (f === 'one') return T.marche;
    if (f === 'two' && T.marchesTwo) return T.marchesTwo;
    if (f === 'few' && T.marchesFew) return T.marchesFew;
    if (f === 'de' && T.marchesDe) return T.marchesDe;
    return T.marches;
  }

  /* Ecrit le nombre, son unite accordee, et l'etat des deux boutons. Le texte
     est refait en DOM (pas en `innerHTML`) : l'unite vient d'une cle de locale
     et ne peut pas devenir du balisage. */
  function ecritMarches(n) {
    if (!elMarches) return;
    elMarches.setAttribute('data-n', String(n));
    elMarches.textContent = String(n) + ' ';
    var u = document.createElement('span');
    u.className = 'cmg-pas__u';
    u.textContent = uniteMarches(n);
    elMarches.appendChild(u);
    /* UN BOUTON QUI SE DESACTIVE SOUS LE DOIGT NE DOIT PAS EMPORTER LE FOCUS
       AVEC LUI : le navigateur le rendrait au `<body>`, hors du panneau, et le
       piege a focus n'aurait plus de point de depart. On le passe au bouton
       d'en face, qui est toujours actif quand l'autre ne l'est plus. */
    var borne = [[btnMoins, n <= 1, btnPlus], [btnPlus, n >= BORNES.n, btnMoins]];
    for (var i = 0; i < borne.length; i++) {
      var b = borne[i][0];
      if (!b) continue;
      b.disabled = borne[i][1];
      if (b.disabled && document.activeElement === b && borne[i][2]) {
        try { borne[i][2].focus(); } catch (e) {}
      }
    }
  }

  function changeMarches(pas) {
    var n = Math.min(BORNES.n, Math.max(1, nMarches() + pas));
    ecritMarches(n);
    calcule();
    dessine();
  }

  /* Renvoie la longueur proposee, en metres, ou `null` si la saisie n'en
     produit pas encore une. Le bouton suit : il ne peut jamais emettre une
     valeur que cette fonction n'a pas ecrite a l'ecran. */
  function calcule() {
    var m = null;
    if (CAS === 'escalier') {
      /* Le calcul lit les MEMES valeurs que le dessin et que la phrase. */
      var p = marches();
      /* LE PARCOURS, PUIS LA MARGE, PUIS LA GRILLE, DANS CET ORDRE (G17b).
         `brut` est la longueur geometrique, celle que la phrase explique ;
         `m` est ce que le visiteur doit commander, marge de pose comprise et
         arrondi au format vendable superieur. Les deux ne sont jamais affiches
         cote a cote : la reponse est `m`, et la ligne juste dessous dit
         combien de centimetres viennent de la marge. */
      var brut = (p.g + p.c) * p.n / 100;
      m = vendable(brut + (MARGE_MARCHE * p.n + MARGE_BOUTS) / 100);
      if (elVal) elVal.textContent = metres(m) + ' m';
      /* ── LA LIGNE DE MARGE NE DIT QU'UNE CHOSE : LA MARGE DE POSE ──────
         Retour de Raph, 08/09 a 00h47 : « retirer la seconde partie de la
         phrase de marge : garder seulement dont 59 cm de marge de pose ».

         G17b avait ajoute une seconde moitie (« et 43 cm pour atteindre le
         format vendu ») pour expliquer l'arrondi sur la grille de la boutique.
         L'arrondi reste, il est simplement SILENCIEUX : `vendable()` continue
         de monter au premier cran vendable, le picker recoit toujours une
         valeur qui est dans sa grille, et le panier porte toujours ce que
         l'ecran annonce. Ce qui disparait est la PHRASE, pas le calcul.

         LE NOMBRE ANNONCE EST DONC LA MARGE DE POSE, `3 x n + 20`, et plus
         l'ecart total : c'est exactement celui que la note de pose explique
         deux lignes plus bas, et le seul que la phrase nomme encore. Sur treize
         marches, 59 cm. Il est toujours strictement positif (20 cm au minimum),
         la ligne n'a donc plus de cas vide a traiter. */
      if (elMarge) {
        var mmMarge = MARGE_MARCHE * p.n + MARGE_BOUTS;
        elMarge.textContent = tpl(T.margeEscalier, { '[cm]': String(mmMarge) });
      }
      /* LES TROIS JETONS SORTENT DES DEUX MEMES CONSTANTES. La phrase dit le
         total puis les deux nombres qui le font, et RIEN DE PLUS depuis G10
         (retour Raph du 07/09 a 00h31 : « ca me parait complexe pour rien,
         simplifie »), avec les MOTS DE G11.2 depuis 02h40 : « la partie plate
         (28 cm) + la partie verticale (18 cm) », les deux memes mots que le
         dessin pose sur ses deux traits d'or. Ce qui a
         disparu n'est pas une information perdue, c'est une information dite
         deux fois : « vos marches peuvent etre differentes, mesurez-en une et
         multipliez » ouvre deja la liste « A retenir », juste en dessous.
         Ces deux nombres ne sont pas ecrits dans la locale, ils sont poses
         ici, comme le total.
         `[c]` ne peut pas mordre dans `[cm]` : le crochet fermant les separe. */
      if (elPhrase) elPhrase.textContent = tpl(T.phraseEscalier, {
        '[cm]': String(p.g + p.c), '[g]': String(p.g), '[c]': String(p.c)
      });
      /* LA LIGNE DE COMPTE RENDU NE SURVIT PAS A UN CHANGEMENT DE MARCHES.
         « Longueur appliquee : 6,00 m » sous une reponse qui dit maintenant
         7,36 m serait deux verites a l'ecran, et la plus vieille est celle qui
         est encore dans le panier. On l'efface a chaque recalcul. */
      poseResultat('', '');
    } else {
      var v = nombre(inCouloir);
      if (isFinite(v) && v > 0) {
        /* La marge est retiree AUX DEUX BOUTS : c'est la meme regle de 5 cm que
           sur les cotes, appliquee a la longueur. */
        m = Math.max(0.1, v - (2 * MARGE) / 100);
      }
      poseResultat(m === null ? '' : tpl(T.resCouloir, { '[l]': metres(m) }), '');
    }
    if (btnApp) {
      if (m === null) btnApp.setAttribute('aria-disabled', 'true');
      else btnApp.removeAttribute('aria-disabled');
    }
    if (PAGE) majPage(m);
    return m;
  }

  /* ── MODE PAGE : LE DESSIN SUIT LA SAISIE, ET LE BOUTON EMPORTE LA LONGUEUR
     Sur la fiche, la longueur ne devient reelle qu'au clic sur « Appliquer » :
     c'est le configurateur qui decide, et lui seul sait ce qui existe. Sur la
     page, il n'y a rien a accrocher a une grille : la longueur SAISIE est la
     reponse, le schema la montre a l'echelle sans attendre, et le bouton la
     transmet a la collection par `?longueur=`, que
     `assets/casemira-couloir-calculator.js` relit et borne a l'arrivee.

     LA VALEUR PASSE PAR L'ATTRIBUT, pas par une variable de ce fichier : c'est
     `selection()` qui la relit, exactement comme elle relit celle du picker.
     Une seule verite, au meme endroit, dans les deux modes. */
  function majPage(m) {
    if (m !== null) root.setAttribute('data-cm-longueur', String(Math.round(m * 100) / 100));
    dessine();
    if (!lienPage) return;
    var base = root.getAttribute('data-cm-lien') || '';
    if (!base) return;
    if (m === null) { lienPage.setAttribute('href', base); return; }
    var l = (Math.round(m * 100) / 100).toFixed(2);
    lienPage.setAttribute('href', base + (base.indexOf('?') < 0 ? '?' : '&') + 'longueur=' + l);
  }

  /* Le bout de la grille POUR LA LARGEUR COURANTE. Il est lu dans le
     metachamp que le picker porte deja sur sa racine (`data-matrix`), analyse
     une seule fois et garde : c'est la seule source qui dise ou la grille
     s'arrete. Depuis le 05/09, ce chiffre ne s'AFFICHE plus : il sert
     uniquement a choisir entre les deux notes (« on est au bout de ce qui se
     commande en ligne » et « voici la longueur la plus proche »). Sur les
     fiches couloir et escalier releves ce jour, il vaut 10,00 m pour les sept
     largeurs, ce que la phrase dit en toutes lettres. */
  var grille = null;
  /* S3, 06/10 : le bout de la GRILLE seule (sans le stock), pour savoir si le
     plafond rendu par `plafond()` est celui de la grille ou celui du stock. */
  function maxGrille(w) {
    if (plafond(w) === null) return null;
    var col = grille && grille[String(w)];
    var m = 0;
    for (var k in col) {
      if (!Object.prototype.hasOwnProperty.call(col, k)) continue;
      var v = Number(k);
      if (isFinite(v) && v > m) m = v;
    }
    return m > 0 ? m : null;
  }
  function plafond(w) {
    if (!picker) return null;
    /* SUR MESURE (berbère) : pas de grille, la borne de la matrice. */
    if (SUR_MESURE) return Number(picker.getAttribute('data-cm-longueur-max')) || null;
    if (grille === null) {
      try {
        grille = (JSON.parse(picker.getAttribute('data-matrix') || '{}') || {}).matrix || {};
      } catch (e) {
        grille = {};
      }
    }
    var col = grille[String(w)];
    if (!col) return null;
    var max = 0;
    for (var k in col) {
      if (!Object.prototype.hasOwnProperty.call(col, k)) continue;
      var v = Number(k);
      if (isFinite(v) && v > max) max = v;
    }
    /* S3, 06/10 : LE BOUT EST CELUI DU STOCK, PAS SEULEMENT CELUI DE LA GRILLE.
       Depuis la synchro S1, les longueurs plus longues que le rouleau du
       fournisseur sont a 0 et le configurateur ne les sert plus. Il pose la
       plus grande longueur DISPONIBLE de la largeur courante dans
       `data-max-dispo` (meme format que `data-cm-longueur`) : on la prend,
       bornee par la grille, quand elle porte sur la largeur demandee. Sans
       l'attribut (configurateur pas encore demarre), la grille, comme avant. */
    var md = Number(picker.getAttribute('data-max-dispo'));
    if (isFinite(md) && md > 0 && Number(picker.getAttribute('data-cm-largeur')) === Number(w)) {
      return max > 0 ? Math.min(md, max) : md;
    }
    return max > 0 ? max : null;
  }

  /* ── LA LONGUEUR VENDABLE IMMEDIATEMENT SUPERIEURE (G17b) ─────────────────
     La marge de pose ne sert a rien si le configurateur la reprend en
     accrochant a la longueur la plus PROCHE : 6,57 m demandes deviendraient
     6,50 m vendus, c'est-a-dire moins que le calcul geometrique lui-meme. Le
     tiroir arrondit donc LUI-MEME, et vers le HAUT, sur la grille reelle de la
     largeur courante, celle que `plafond()` lit deja dans `data-matrix`. Le
     picker recoit alors une valeur qui EST dans sa grille : son
     « plus proche » la retrouve a l'identique, et il n'y a plus qu'une seule
     longueur a l'ecran.

     LA GRILLE N'EST PAS REGULIERE, ET C'EST TOUT L'INTERET DE LA LIRE plutot
     que de poser un pas en dur. Releve Admin du 07/09, lecture seule, sur une
     fiche escalier et pour ses sept largeurs : 56 crans, de 0,50 m a 5,00 m par
     10 cm, puis de 5,00 m a 10,00 m par 50 cm. Un escalier ordinaire tombe
     dans la seconde moitie : 13 marches demandent 6,57 m et se commandent donc
     en 7,00 m. C'est aussi pour cela que la ligne « dont X cm de marge de
     pose » existe : elle rend visible ce que l'arrondi ajoute, au lieu de le
     laisser deviner.

     TROIS SORTIES, ET AUCUNE NE MENT :
       · la grille repond : on rend son premier cran >= la valeur ;
       · la valeur depasse le dernier cran : on rend la valeur TELLE QUELLE,
         pour que `applique()` reconnaisse le bout de la grille et affiche la
         note « Jusqu'a 10 m. Au-dela, c'est possible : ecrivez-nous » ;
       · pas de grille lisible (mode page, matrice absente) : la grille de
         repli, qui a la meme forme que la vraie. */
  function vendable(m) {
    if (!isFinite(m) || m <= 0) return m;
    /* SUR MESURE (berbère) : tout se commande au centimètre, on monte au
       centimètre supérieur. */
    if (SUR_MESURE) return Math.ceil(m * 100 - 0.005) / 100;
    var w = picker ? Number(picker.getAttribute('data-cm-largeur')) : NaN;
    var col = null;
    var maxW = null;
    if (isFinite(w) && w > 0) {
      maxW = plafond(w); /* amorce l'analyse de `data-matrix`, une seule fois */
      col = grille && grille[String(w)];
    }
    if (col) {
      var meilleur = null;
      for (var k in col) {
        if (!Object.prototype.hasOwnProperty.call(col, k)) continue;
        var v = Number(k);
        /* Le demi-centimetre de tolerance est celui de `applique()` : sans lui,
           une longueur deja pile sur un cran remonterait d'un cran a cause du
           flottant. */
        if (!isFinite(v) || v < m - 0.005) continue;
        /* S3, 06/10 : jamais un cran au-dela de la longueur DISPONIBLE. Une
           demande plus longue sort par « la valeur telle quelle » ci-dessous,
           et `applique()` affiche alors la note du plafond. */
        if (maxW !== null && v > maxW + 0.005) continue;
        if (meilleur === null || v < meilleur) meilleur = v;
      }
      if (meilleur !== null) return meilleur;
      return m;
    }
    /* Le pas change A 5 m : en dessous, les crans sont a 10 cm ; au-dessus, a
       50 cm. Une valeur pile sur 5 m reste dans la moitie basse, ou elle est un
       cran a part entiere. */
    var pas = m > REPLI.seuil + 0.005 ? REPLI.haut : REPLI.bas;
    return Math.round(Math.ceil(m / pas - 0.005) * pas * 100) / 100;
  }

  function applique() {
    var m = calcule();
    if (m === null || !picker) return;
    var w = Number(picker.getAttribute('data-cm-largeur'));
    if (!isFinite(w)) return;
    /* CONTRAT § 8.1 : les DEUX cles, toujours. `width` est RELUE, jamais
       devinee ; `length` est arrondie au centimetre, l'unite de la grille. */
    var demande = Math.round(m * 100) / 100;
    document.dispatchEvent(new CustomEvent('couloir:set-dimensions', {
      detail: { width: w, length: demande }
    }));

    /* Le picker a accroche a ce qui existe : on relit l'etat DOM pour dire ce
       qui a REELLEMENT ete retenu, pas ce qui a ete demande. ET ON DIT L'ECART
       QUAND IL Y EN A UN. Un « Longueur necessaire : 12,00 m » suivi d'un
       « Longueur appliquee : 10,00 m » sans un mot, c'est une substitution
       silencieuse : le visiteur repart avec un tapis trop court en croyant
       avoir commande le sien. Trois etats, trois phrases :
       - la longueur retenue EST celle demandee : on le dit simplement ;
       - elle est en dessous ET la grille s'arrete la : on dit la MEME phrase
         que le repere du bas du tiroir, « Jusqu'a 10 m. Au-dela, c'est
         possible : ecrivez-nous », lien contact compris. Retour Raph du 05/09
         18h28 : plus un mot de decoupe en plusieurs les, qui ne se comprenait
         pas ; la grille reste interrogee, mais seulement pour SAVOIR qu'on est
         au bout, pas pour chiffrer un plafond a l'ecran ;
       - elle differe pour une autre raison (accrochage au pas de la grille,
         cellule epuisee) : on nomme la longueur demandee et la retenue. */
    var sel = selection();
    if (!sel || !elRes) return;
    var retenue = sel.l;
    var pose = tpl(T.applique, { '[l]': metres(retenue) });
    if (Math.abs(retenue - demande) < 0.005) {
      poseResultat(pose, '');
      return;
    }
    var max = plafond(w);
    if (retenue < demande && max !== null && retenue >= max - 0.005) {
      /* S3, 06/10 (decision du pilote apres revue) : quand le bout atteint est
         celui du STOCK (plus court que la grille), on ne dit pas « jusqu'a
         10 m » : on dit la longueur reellement disponible, avec la phrase du
         configurateur, puis le lien contact. La longueur conseillee affichee
         plus haut reste le besoin calcule. Bout de la grille : note d'avant. */
      var mg = maxGrille(w);
      if (T.maxDispoDepasse && mg !== null && max < mg - 0.005) {
        poseResultat(pose, tpl(T.maxDispoDepasse, { '[max]': metres(max) }), 'phrase');
      } else {
        poseResultat(pose, T.notePlafond, true);
      }
      return;
    }
    poseResultat(pose, tpl(T.noteProche, { '[d]': metres(demande) }));
  }

  function surSaisie() {
    couloirTouche = true;
    calcule();
  }
  if (inCouloir) inCouloir.addEventListener('input', surSaisie);
  /* Le stepper de l'escalier : deux boutons, un pas d'une marche. Pas
     d'auto-repetition a l'appui long, volontairement : 60 marches au maximum,
     et un compteur qui s'emballe sous le doigt est plus penible qu'un appui de
     plus. Le clavier est servi par le bouton lui-meme (Entree et Espace). */
  if (btnMoins) btnMoins.addEventListener('click', function () { changeMarches(-1); });
  if (btnPlus) btnPlus.addEventListener('click', function () { changeMarches(1); });
  if (btnApp) {
    btnApp.addEventListener('click', function () {
      if (btnApp.getAttribute('aria-disabled') === 'true') return;
      applique();
    });
  }

  /* LA SORTIE DU MODE PAGE. Tout ce qui suit n'existe que pour un panneau :
     verrou, historique, piege a focus, geste, declencheurs. `noteAdresse()`
     sort sur son `if (!pousse) return`, `pousse` valant `undefined`. */
  if (PAGE) {
    if (CAS === 'escalier') ecritMarches(nMarches());
    calcule();
    dessine();
    return;
  }

  /* ── Le verrou de defilement ────────────────────────────────────────────── */
  var barrePosee = false;
  function mesureLaBarre() {
    if (racine.classList.contains('cmg-lock')) return;
    racine.style.setProperty('--cmg-sbw', (window.innerWidth - racine.clientWidth) + 'px');
    barrePosee = true;
  }
  window.addEventListener('resize', function () {
    mesureLaBarre();
    if (ouvert) dessine();
  });

  /* ON NE RETIRE QUE CE QU'ON A POSE, ET SEULEMENT SI PLUS PERSONNE NE LA
     TIENT. `cm-over` est partagee par cinq surcouches. Retirer la classe en
     aveugle a la fermeture du guide rallumerait le bandeau de consentement et
     la pastille de chat PAR-DESSUS une surcouche encore vivante - le tiroir de
     navigation, le panier, la recherche - ce qui est exactement la faute que
     `casemira-c6-loupe.js` (vague 4, § « ON NE RETIRE PAS cm-over SI QUELQU'UN
     D'AUTRE LA REVENDIQUE ») puis `casemira-c6-tiroir.js` (vague R1) ont
     corrigee chacune de leur cote. Le guide s'ouvre depuis la colonne d'achat
     d'une fiche couloir, ou le panier peut deja etre ouvert : le cas n'est pas
     theorique.

     Meme forme que les deux precedents : les revendicateurs sont NOMMES un par
     un, et pas devines par un selecteur large - la lecon de la vague 4 est
     qu'un selecteur trop large (`.drawer[open]`) laisse `cm-over` posee pour
     toujours, et qu'un bandeau de consentement qu'on oublie de RALLUMER est
     un defaut plus grave que l'inverse. */
  /* `cmq-locked` : la mini-fiche des collections (`casemira-collection-plus.js`,
     ajout C5, 05/09). Les deux ne cohabitent pas aujourd'hui - le guide ne vit
     que sur une fiche couloir - mais la liste des revendicateurs se tient a
     jour d'un bloc dans les cinq fichiers, sans quoi le prochain qui les
     rapproche retrouve le defaut. */
  function quelquUnDAutreLaTient() {
    return (
      document.documentElement.classList.contains('cmk-open') ||
      document.documentElement.classList.contains('cmq-locked') ||
      /* `cmt-lock` : le guide des tailles des fiches HORS couloir
         (`casemira-guide-tailles.js`, ajout R5, 05/09). Les deux tiroirs ne
         cohabitent jamais - les chemins de rendu sont disjoints par
         construction - mais la liste des revendicateurs se tient a jour d'un
         bloc dans les cinq fichiers, sans quoi le prochain qui les rapproche
         retrouve le defaut. Ligne ADDITIVE : rien d'autre ne bouge ici. */
      document.documentElement.classList.contains('cmt-lock') ||
      document.body.classList.contains('search-open') ||
      document.body.classList.contains('search-is-open') ||
      !!document.querySelector('menu-drawer[open]')
    );
  }

  function verrouille() {
    if (!barrePosee) mesureLaBarre();
    racine.classList.add('cmg-lock');
    /* Regle Une Surcouche a la Fois : `cm-over` efface la bulle de chat et le
       bandeau de consentement, qui sont poses a des profondeurs qu'aucun
       palier nomme ne peut depasser (`casemira-tokens.css`). */
    racine.classList.add('cm-over');
  }
  function deverrouille() {
    /* `cmg-lock` part D'ABORD : c'est la marque par laquelle les deux autres
       arbitres nous reconnaissent, et l'interroger en la portant encore ferait
       du guide son propre revendicateur. */
    racine.classList.remove('cmg-lock');
    if (!quelquUnDAutreLaTient()) racine.classList.remove('cm-over');
  }

  /* ── Ouverture, fermeture, piege a focus ────────────────────────────────── */
  var ouvert = false;
  var declencheur = null;
  var minuteur = null;
  var pousse = false;      /* une entree d'historique nous appartient */
  var popAttendu = false;  /* le pop que NOUS avons demande, a ignorer */

  /* ── L'historique ────────────────────────────────────────────────────────
     Precedent : `casemira-cart.js` (§ « L'historique »). Sans entree empilee,
     le premier reflexe d'un visiteur pris dans une feuille plein ecran - le
     geste de retour Android, le glissement depuis le bord sur iOS - le fait
     QUITTER LA PAGE au lieu de refermer le panneau. Sur une fiche couloir,
     cela lui coute la largeur et la longueur qu'il venait de choisir.

     On empile UNE SEULE entree, gardee par `pousse` : le guide ne s'ouvre pas
     deux fois de suite sans se fermer (`ouvre` sort tout de suite si `ouvert`),
     mais la garde rend la paire empile / depile sure quoi qu'il arrive.
     `popAttendu` distingue le pop que nous provoquons nous-memes, en fermant a
     la croix ou a Echap, de celui que le visiteur declenche. */
  /* ON N'EMPILE PAS PAR-DESSUS UNE ENTREE QUI N'EST PAS A NOUS, ET LA RECETTE
     DU 05/09 (c5-guide-surcouche.mjs, controle B2) DIT POURQUOI. Le tiroir
     panier empile lui aussi, et son `popstate` se referme sur TOUT pop qu'il
     n'a pas demande. Panier ouvert, guide ouvert par-dessus : fermer le guide
     a la croix appelait `history.back()`, le panier voyait passer le pop et se
     refermait avec lui, sans que personne le lui ait demande.
     Tant que `cmk-open` est la, le panier tient deja une entree : on lui
     laisse, et le geste de retour refermera les deux d'un coup par notre
     `popstate`. Le guide reste refermable a la croix et a Echap, ce qui
     n'empile ni ne depile rien. */
  function empile() {
    if (pousse) return;
    if (document.documentElement.classList.contains('cmk-open')) return;
    try {
      history.pushState({ cmgGuide: 1 }, '', location.href);
      pousse = true;
      urlVivante = location.href;
    } catch (e) {
      pousse = false;
    }
  }

  /* ── L'ADRESSE APRES LA SORTIE, ET IL Y A DEUX SORTIES ───────────────────
     Motif pose par `casemira-guide-tailles.js` (G3.4, § « L'adresse apres la
     sortie »), porte ici a l'identique.

     Notre entree est empilee avec l'adresse du MOMENT DE L'OUVERTURE. Cette
     adresse peut changer ensuite sans qu'on quitte la page, et ce sont des
     `replaceState` : le selecteur de format (`casemira-size-picker.js`,
     `paintUrl` l.870) y ecrit `?variant=`, l'ancre douce de la fiche
     (`casemira-pdp-reskin.js` l.558) y ecrit `#avis`. Ils ecrasent NOTRE
     entree, pas la precedente. Les deux sorties perdaient donc ce que la page
     affiche encore :

       · la sortie que NOUS demandons (croix, voile, Echap) appelle
         `history.back()` : on retient l'adresse juste avant de sortir
         (`urlSortie`) et on la repose sur l'entree d'arrivee ;
       · le GESTE DE RETOUR du visiteur depile notre entree sans nous prevenir,
         et l'adresse a DEJA recule quand `popstate` arrive : `urlVivante`,
         relevee tant que notre entree existe, joue le meme role.

     Dans les deux cas c'est un `replaceState` : AUCUNE entree ajoutee,
     `history.state` repasse tel quel, et le geste de retour suivant quitte
     toujours la page. */
  var urlSortie = '';   /* l'adresse d'avant NOTRE `history.back()`         */
  var urlVivante = '';  /* l'adresse tant que notre entree est empilee      */
  /* Relevee a chaque dessin : c'est le seul moment ou l'adresse a pu bouger
     pendant que le panneau est ouvert. Gardee par `pousse`, pour ne jamais
     reposer plus tard l'adresse d'une ouverture precedente.

     ET GARDEE PAR NOTRE MARQUE D'ETAT (G4.9, controle A5b de la fenetre G3).
     Nous ne sommes ni le seul ecouteur de `popstate` de la fiche, ni le
     premier : `casemira-size-picker.js` l.1663 y appelle `paint()`, qui emet
     `cm:variant:instant`, et un panneau encore ouvert se redessine sur cet
     evenement. `noteAdresse()` s'executait alors APRES le depilage et AVANT
     notre propre ecouteur, et relevait l'adresse d'AVANT l'ouverture : la
     restitution devenait un coup pour rien. `history.state` porte `cmgGuide`
     tant que NOTRE entree est celle du dessus - le
     `replaceState(history.state, ...)` du selecteur la repasse tel quel - et
     ne le porte plus une fois depilee. Un tiers qui ecraserait l'etat nous
     fait garder la derniere adresse relevee : degradation, jamais fausse
     adresse. */
  function noteAdresse() {
    if (!pousse) return;
    var st = null;
    try { st = history.state; } catch (e) { st = null; }
    if (!st || !st.cmgGuide) return;
    urlVivante = location.href;
  }

  function depile() {
    if (!pousse) return;
    pousse = false;
    popAttendu = true;
    urlSortie = location.href;
    urlVivante = '';
    try {
      history.back();
    } catch (e) {
      popAttendu = false;
      urlSortie = '';
    }
  }

  window.addEventListener('popstate', function () {
    if (popAttendu) {
      popAttendu = false;
      if (urlSortie && location.href !== urlSortie) {
        try { history.replaceState(history.state, '', urlSortie); } catch (e) {}
      }
      urlSortie = '';
      return;
    }
    /* ON NE SE FERME QUE SUR NOTRE PROPRE ENTREE, et la recette du 05/09
       (controle D1) dit pourquoi. Quand le panier tient l'entree, c'est SA
       fermeture qui appelle `history.back()` : sans cette garde, refermer le
       panier pose sur le guide emportait le guide avec lui, alors que le
       visiteur revenait justement a lui. Symetrique de la garde de `empile`.

       CE QUE CELA LAISSE, ASSUME : panier et guide ouverts ensemble, un geste
       de retour referme le panier et laisse le guide, qui n'a alors plus
       d'entree a lui. Un second geste quitte la page. C'est l'etat d'avant ce
       chantier pour ce seul cas, et il demande d'avoir empile par-dessus une
       surcouche qui empile deja. */
    if (!pousse) return;
    if (ouvert) {
      /* L'adresse a deja recule : on repose celle que la page affiche encore,
         AVANT de fermer, et sans ajouter d'entree. */
      if (urlVivante && location.href !== urlVivante) {
        try { history.replaceState(history.state, '', urlVivante); } catch (e) {}
      }
      urlVivante = '';
      /* L'entree vient d'etre depilee par le navigateur : elle ne nous
         appartient plus, et `ferme` ne doit pas rappeler `history.back()`. */
      pousse = false;
      ferme(true);
    }
  });

  function dureeSortie() {
    var v = getComputedStyle(racine).getPropertyValue('--dur-3').trim();
    var ms = parseFloat(v);
    if (!isFinite(ms)) return 420;
    if (v.slice(-2) !== 'ms' && v.slice(-1) === 's') ms *= 1000;
    return ms;
  }

  function focusables() {
    if (!panneau) return [];
    var sel = 'button:not([disabled]):not([aria-disabled="true"]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(panneau.querySelectorAll(sel)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function clavier(e) {
    if (!ouvert) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      ferme();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var premier = f[0], dernier = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === premier || !panneau.contains(a))) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && (a === dernier || !panneau.contains(a))) { e.preventDefault(); premier.focus(); }
  }

  function surVariante() { if (ouvert) dessine(); }

  /* ── `cmg-ouvert` : L'OUVERTURE LOGIQUE, ET ELLE N'EST PAS `cmg-lock` ─────
     Deux marques, deux roles, et il ne faut pas les melanger :

       · `cmg-lock` dit « le panneau OCCUPE ENCORE L'ECRAN ». Elle ne part que
         dans `fin()`, `dureeSortie() + 40` ms apres la fermeture logique, le
         temps que le panneau finisse de sortir. C'est ce qu'il faut pour
         arbitrer `cm-over` : le bandeau de consentement ne doit pas se
         rallumer PENDANT la sortie ;
       · `cmg-ouvert` dit « le guide est ouvert », au sens de la machine a
         etats. Elle est posee et retiree SYNCHRONIQUEMENT, avant tout differe :
         collee a `ouvert = true` dans `ouvre`, en tete de `ferme`. Collee, et
         pas en tete de `ouvre` : entre les deux il y a le deplacement du
         panneau, `verrouille()`, `calcule()` et `dessine()`. Si l'un d'eux
         levait, `ouvert` resterait faux et la marque resterait posee sur la
         racine, sans personne pour la retirer - un guide logiquement ferme
         que le panier croirait ouvert pour le reste de la visite. Les deux
         etats ne peuvent pas diverger tant qu'ils sont ecrits cote a cote.

     LA RECETTE QUI L'A EXIGEE (revue R7, tour 2, 05/09). Le panier lit une de
     ces marques pour savoir s'il doit empiler une entree d'historique. S'il
     lisait `cmg-lock`, il resterait aveugle pendant les 460 ms de la sortie :
     le visiteur qui ferme le guide au voile puis tape l'icone panier dans la
     foulee - deux touchers naturels, au meme endroit - obtenait un panier qui
     n'empile pas, et son geste de retour QUITTAIT LA PAGE. C'est exactement ce
     que le bloc « L'historique » existe pour empecher.

     Le miroir cote guide n'a jamais eu ce trou parce qu'il lit `cmk-open`, que
     le panier retire synchroniquement. `cmg-ouvert` donne au panier la meme
     qualite de signal. */
  function ouvre(dep) {
    if (ouvert) return;
    /* LE TIROIR QUI S'OUVRE NE TRAINE PAS LE GESTE DU PRECEDENT (fix round 1
       de la revue G10). `bouge` dit « un glissement vient de deplacer le
       panneau » et sert au clic du voile a ne pas prendre un clic fantome pour
       un tap. Il n'etait remis a zero que par un `touchstart` ou un
       `pointerdown` : ferme au geste puis rouvert par un chemin qui n'en
       envoie pas (le clavier, un declencheur active au clavier, un script),
       le tiroir gardait le drapeau leve et refusait UNE fois de se fermer au
       voile. Une seconde d'inattention pour le visiteur, et rien qui se
       raconte. Il part avec l'ouverture, ou il n'a plus aucun sens. */
    bouge = false;
    declencheur = dep || null;
    if (minuteur) { clearTimeout(minuteur); minuteur = null; }

    /* Parti pris 1 (voir l'en-tete) : le panneau se cale sur la FENETRE, quoi
       que fassent les autres chantiers de la colonne d'achat. */
    if (root.parentNode !== document.body) document.body.appendChild(root);

    root.hidden = false;
    verrouille();

    /* La longueur du couloir est proposee a partir de ce qui est deja choisi,
       marge comprise : l'outil arrive rempli et se lit comme un exemple, au
       lieu d'un champ vide a remplir avant de comprendre a quoi il sert. Une
       fois que le visiteur y a touche, on ne recrit plus rien. */
    if (CAS === 'couloir' && inCouloir && !couloirTouche) {
      var s0 = selection();
      if (s0) inCouloir.value = metres(s0.l + (2 * MARGE) / 100);
    }
    calcule();
    dessine();

    /* Un reflow force, une seule fois : sans lui le navigateur regroupe le
       passage de `hidden` et l'ajout de `is-open` dans le meme calcul de style,
       et la transition d'entree n'a pas de point de depart. */
    void root.offsetWidth;
    root.classList.add('is-open');
    racine.classList.add('cmg-ouvert');
    ouvert = true;

    document.addEventListener('keydown', clavier, true);
    document.addEventListener('couloir:variant-change', surVariante);
    document.addEventListener('berbere:change', surVariante);
    majDeclencheurs(true);
    empile();
    if (croix) setTimeout(function () { try { croix.focus(); } catch (e) {} }, 40);
  }

  /* `depuisHistorique` : la fermeture vient du geste de retour, l'entree a
     deja ete depilee par le navigateur. La depiler une seconde fois ferait
     reculer le visiteur d'une page de plus. */
  function ferme(depuisHistorique) {
    if (!ouvert) return;
    /* ── LE GESTE NE SURVIT PAS A LA FERMETURE, QUELLE QU'ELLE SOIT ────────
       (fix round 1 de la revue G10.) `ferme()` a QUATRE appelants qui ne
       passent pas par le geste : la croix, Echap, le voile et `popstate`. Un
       doigt encore pose au moment ou l'un d'eux tire laissait `cmg-drag` sur
       la racine et `--cmg-dy` sur le panneau : le panneau sortait sans
       transition, et il RENTRAIT decale a l'ouverture suivante, puisque
       personne n'allait plus les retirer (le `touchend` d'un tiroir ferme sort
       sur `if (!glisse)`... mais seulement si le geste a ete arme, et un geste
       arme sur un tiroir qu'on vient de fermer autrement n'a plus de porte).
       Le nettoyage est mis ICI plutot que dans chaque appelant : une seule
       porte de fermeture, un seul menage. Quand c'est le GESTE qui ferme,
       `gFin` a deja repose le panneau et remis `glisse` a faux : l'appel sort
       tout de suite, il ne coute rien et il ne defait rien. */
    gAbandonne();
    /* EN TETE, AVANT TOUT DIFFERE : voir le pave de `cmg-ouvert` sur `ouvre`.
       `depile()` est appele quelques lignes plus bas et le panier peut etre
       sollicite dans la milliseconde qui suit ; la marque doit deja etre
       partie. `cmg-lock`, elle, ne part que dans `fin()`. */
    racine.classList.remove('cmg-ouvert');
    ouvert = false;
    root.classList.remove('is-open');
    document.removeEventListener('keydown', clavier, true);
    document.removeEventListener('couloir:variant-change', surVariante);
    document.removeEventListener('berbere:change', surVariante);
    majDeclencheurs(false);
    if (!depuisHistorique) depile();

    /* Le verrou ne se leve qu'une fois le panneau sorti : le lever tout de
       suite rendrait la barre de defilement pendant le mouvement, et la page
       sauterait de sa largeur sous les yeux du visiteur. */
    var fin = function () {
      root.hidden = true;
      deverrouille();
      minuteur = null;
    };
    var d = dureeSortie();
    if (d <= 20) fin();
    else minuteur = setTimeout(fin, d + 40);

    if (declencheur && declencheur.focus) { try { declencheur.focus(); } catch (e) {} }
    declencheur = null;
  }

  function majDeclencheurs(etat) {
    var l = document.querySelectorAll('.cm-guide-tiroir-trigger');
    for (var i = 0; i < l.length; i++) l[i].setAttribute('aria-expanded', etat ? 'true' : 'false');
  }

  /* ══════════════════════════════════════════════════════════════════════
     LE GESTE DE FERMETURE, REPRIS DU PANIER                   G10, 07/09/2026
     ----------------------------------------------------------------------
     RAPH, 07/09 A 00h31 : « tu peux les re-slider pour les fermer, pas oblige
     d'appuyer sur la croix, une animation fluide ultra smooth, comme le
     panier ».

     « COMME LE PANIER » EST PRIS AU MOT. Ce bloc est le § 2 de
     `assets/casemira-cart.js` porte ici, avec ses cinq seuils a l'identique,
     sa fenetre de vitesse de 90 ms, son elastique court a contresens, sa
     regle du `touchmove` NON PASSIF et sa lecon centrale : la propriete
     personnalisee est posee sur le PANNEAU et la classe sur la RACINE DU
     TIROIR, jamais sur `<html>`. Une propriete personnalisee est HERITEE :
     la reposer sur la racine du document invalide le style de tout le
     document a chaque image, pour deplacer un seul element (35 ms par pas
     mesures le 30/08 sur la feuille de filtres avant correction).
     Ecrire d'autres seuils ici ferait deux gestes qui se ressemblent, ce qui
     est pire que deux gestes qui different.

     L'AXE SUIT L'OUVERTURE, PARCE QUE LA FEUILLE DE STYLE LE FAIT DEJA. Sous
     768 px le panneau monte du bas (`translateY(100%)`) : on le glisse VERS
     LE BAS. Au-dessus, il vient du bord droit (`translateX(100%)`) : on le
     glisse VERS LA DROITE. La frontiere est celle du CSS, ecrite une fois
     ici sous le meme nombre.

     POURQUOI `(pointer: coarse)` ET PAS UNE LARGEUR. Le brief demande le
     geste sur telephone. Une largeur dirait « petite fenetre », pas « doigt » :
     une fenetre de bureau retrecie prendrait le geste sans jamais pouvoir le
     faire, et une tablette large en portrait le perdrait alors qu'elle ouvre
     le panneau par le cote. Le pointeur grossier est la question qu'on pose
     vraiment. C'est aussi ce qui protege la souris : au bureau, un panneau
     qui part parce que la main a derive de 80 px serait une perte de saisie.

     LES TROIS ZONES QUI L'ARMENT, ET LE CONFLIT QU'ELLES EVITENT
       · l'EN-TETE (`.cmg-tete`), qui est la poignee de ce tiroir : rien n'y
         est cliquable sauf la croix, et un bouton n'arme jamais rien ;
       · le VOILE, au doigt seulement, comme le panier ;
       · le CORPS DEFILANT, et SEULEMENT quand il est deja en haut de son
         defilement (`scrollTop === 0`) ET dans le sens de la fermeture.
         C'est le choix du panier, et c'est le seul qui ne prend pas un
         defilement pour une fermeture : le contenu de ces tiroirs defile
         (scene, legende, formats, « A retenir »), et un geste vers le bas au
         milieu de la liste doit remonter la liste, pas fermer le panneau.
         Le controle est refait dans `gDecide` : entre l'appui et le sixieme
         pixel, le doigt a pu faire defiler.

     CE QUI N'ARME RIEN, ET C'EST LA REGLE QUI PROTEGE LE RESTE DU TIROIR.
     `button, a[href], input, select, textarea, [role="button"]` : la croix, le
     stepper de marches, le champ de longueur, les pastilles de format et le
     bouton de sortie sont tous dedans. Un tap sur un format ne peut donc pas
     devenir un glissement, et la regle G3.4 (le tiroir RESTE OUVERT quand on
     choisit un format) tient sans avoir a se defendre. C'est aussi la lecon du
     panier sur `setPointerCapture`, qui DEPLACE LA CIBLE DU `click` : armer
     depuis un bouton volerait le clic de ce bouton.

     LA SORTIE PASSE PAR `ferme()`, SANS ARGUMENT, exactement comme la croix.
     Donc : `depile()`, la restitution de `urlSortie` / `urlVivante` avec son
     `?variant=`, le focus rendu au declencheur, le minuteur de `fin()`. Un
     second chemin de fermeture aurait ete un second historique.

     MOUVEMENT REDUIT. Rien a ajouter : les tokens ramenent `--dur-3` a 1 ms,
     la feuille supprime la transition du panneau, `dureeSortie()` rend alors
     une valeur sous 20 ms et `ferme()` remet la page en etat dans la meme
     pile. Le panneau ne joue aucune sortie animee, le retour elastique est
     instantane, et le suivi du doigt reste : ce n'est pas une animation, c'est
     la main du visiteur.
     ══════════════════════════════════════════════════════════════════════ */

  /* Les cinq seuils du panier, valeur pour valeur (`casemira-cart.js` § 0). */
  var G_SLOP = 6;        /* px : en deca, c'est un tap                       */
  var G_DISTANCE = 80;   /* px : au-dela, on ferme                           */
  var G_VELOCITY = 0.5;  /* px/ms : un geste vif vaut une longue distance    */
  var G_WINDOW = 90;     /* ms : la vitesse se lit sur un lancer             */
  var G_RUBBER = 56;     /* px : course maximale a contresens                */
  var G_RUBBER_F = 0.15; /* 112 px de geste ne remontent le panneau que de 18 */
  var G_COTE = 768;      /* px : la frontiere feuille / tiroir de la feuille  */

  var glisse = false;
  var arme = false;
  var idPointeur = null;
  var d0 = 0;      /* la coordonnee de depart sur l'axe du geste */
  var t0 = 0;
  var course = 0;  /* la course pleine du panneau, mesuree UNE FOIS */
  var trace = [];
  var bouge = false;

  function auDoigt() {
    try {
      return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    } catch (e) {
      return false;
    }
  }

  /* L'AXE EST POSE PAR LA MEME QUESTION QUE LA FEUILLE DE STYLE, ET C'EST
     VOLONTAIREMENT UN `matchMedia` PLUTOT QU'UN `innerWidth` (fix round 1 de
     la revue G10). La feuille bascule le panneau du bas vers le cote sur
     `@media (min-width: 768px)` : si le JS repond a une AUTRE question, les
     deux peuvent se contredire, et le doigt pousse alors le panneau sur un axe
     ou il ne sort pas.
     Ils se contredisent pour de vrai : `window.innerWidth` est la fenetre
     VISUELLE, celle que le pincement retrecit et que le navigateur elargit
     quand une page deborde ; `(min-width: …)` interroge la fenetre de MISE EN
     PAGE, celle qui a decide du style. Releve au banc du 07/09, fiche rendue
     sans sa feuille de theme : `clientWidth` 390, `innerWidth` 1560. Le meme
     ecart se produit chez un visiteur qui a pince pour zoomer.
     Le repli sur `innerWidth` existe pour les navigateurs sans `matchMedia`,
     qui n'auraient de toute facon pas de `(pointer: coarse)` et n'armeraient
     donc jamais le geste. */
  function axe() {
    try {
      if (window.matchMedia) return window.matchMedia('(min-width: ' + G_COTE + 'px)').matches ? 'x' : 'y';
    } catch (e) {
      /* repli */
    }
    return window.innerWidth >= G_COTE ? 'x' : 'y';
  }
  function coord(x, y) { return axe() === 'x' ? x : y; }

  function echantillon(d, t) {
    trace.push({ d: d, t: t });
    while (trace.length > 2 && t - trace[0].t > G_WINDOW) trace.shift();
  }

  function vitesse(d, t) {
    var a = trace.length ? trace[0] : { d: d0, t: t0 };
    return (d - a.d) / Math.max(1, t - a.t);
  }

  function decalage(dd) {
    if (dd >= 0) return dd;
    /* A contresens : elastique COURT, le facteur du panier. */
    return Math.max(-G_RUBBER, dd * G_RUBBER_F);
  }

  function corpsDefilant() { return root.querySelector('.cmg-corps'); }

  /* LA COURSE EST MESUREE UNE SEULE FOIS, A L'ARMEMENT. Elle ne sert qu'au
     fondu du voile ; la lire a chaque image mettrait un calcul de mise en page
     DANS la boucle du geste, c'est-a-dire le contraire de 60 images par
     seconde. Le panneau ne change pas de taille pendant qu'un doigt le
     pousse : une mesure suffit. */
  function mesureCourse() {
    course = 0;
    if (!panneau || !panneau.getBoundingClientRect) return;
    try {
      var r = panneau.getBoundingClientRect();
      course = axe() === 'x' ? r.width : r.height;
    } catch (e) {
      course = 0;
    }
  }

  function gesteArme() {
    root.classList.add('cmg-drag');
    if (panneau && panneau.style) panneau.style.willChange = 'transform';
    mesureCourse();
  }

  /* Le panneau suit le doigt en TRANSLATION SEULE (regle Transform ou Rien) et
     le voile s'estompe dans la meme proportion : c'est la seule chose que ce
     bloc ajoute au motif du panier, et c'est ce que le brief demande. Une
     opacite ne deplace rien et ne coute aucun calcul de mise en page. */
  function gesteBouge(dd) {
    if (!panneau || !panneau.style) return;
    panneau.style.setProperty(axe() === 'x' ? '--cmg-dx' : '--cmg-dy', Math.round(dd) + 'px');
    if (!root.style || !course) return;
    var part = dd > 0 ? Math.min(1, dd / course) : 0;
    root.style.setProperty('--cmg-fondu', String(Math.round((1 - part) * 100) / 100));
  }

  /* Le retour elastique EST le retrait de la propriete : la transition du
     panneau reprend dans la meme image et ramene le `transform` a zero, sur
     `--dur-3` et `--ease-both`, les durees de DESIGN.md. */
  function gesteRepose() {
    root.classList.remove('cmg-drag');
    if (root.style) root.style.removeProperty('--cmg-fondu');
    if (panneau && panneau.style) {
      panneau.style.removeProperty('--cmg-dy');
      panneau.style.removeProperty('--cmg-dx');
      panneau.style.willChange = '';
    }
  }

  function gDebut(cible, x, y, t, id, capture, type) {
    if (glisse) return true;
    bouge = false;
    if (!ouvert || !auDoigt()) return false;
    if (!cible || typeof cible.closest !== 'function') return false;

    /* UN GESTE NE PART JAMAIS D'UNE COMMANDE (lecon du panier, vague 1) :
       `setPointerCapture` DEPLACE LA CIBLE DU `click`, et la croix, le
       stepper, le champ de longueur, les pastilles de format et le bouton de
       sortie deviendraient sans effet. */
    if (cible.closest('button, a[href], input, select, textarea, [role="button"]')) return false;

    /* LE VOILE N'ARME AUCUN GESTE A LA SOURIS (lot I du panier) : glisser un
       voile est un geste de doigt ; a la souris on clique a cote, et armer
       volerait ce clic. Ici la souris est deja exclue par `auDoigt()` ; la
       ligne reste parce que le stylet, lui, passe. */
    var surVoile = !!cible.closest('.cmg-voile');
    if (surVoile && type === 'mouse') return false;
    var surPoignee = !!cible.closest('.cmg-tete') || surVoile;
    var scroller = corpsDefilant();
    var surCorps = !surPoignee && scroller && scroller.contains(cible);
    if (!surPoignee && !surCorps) return false;
    if (surCorps && scroller.scrollTop > 0) return false;

    glisse = true;
    arme = surPoignee;
    idPointeur = id;
    d0 = coord(x, y);
    t0 = t;
    trace.length = 0;
    echantillon(d0, t);
    if (surPoignee) {
      gesteArme();
      if (capture && panneau && panneau.setPointerCapture) {
        try {
          panneau.setPointerCapture(id);
        } catch (e) {
          /* capture refusee : le geste marche quand meme */
        }
      }
    }
    return true;
  }

  function gDecide(x, y, capture) {
    if (!glisse) return false;
    if (arme) return true;
    var dd = coord(x, y) - d0;
    /* Depuis le corps, on n'accapare le geste qu'une fois le seuil de tap
       franchi ET seulement dans le sens de la fermeture. */
    if (dd <= G_SLOP) {
      if (dd < -G_SLOP) glisse = false;
      return false;
    }
    /* RELU ICI, ET C'EST LE POINT QUI PROTEGE LE DEFILEMENT INTERNE : entre
       l'appui et le sixieme pixel, le doigt a pu faire descendre la liste. Un
       corps qui n'est plus en haut rend le geste au defilement. */
    var scroller = corpsDefilant();
    if (scroller && scroller.scrollTop > 0) {
      glisse = false;
      return false;
    }
    arme = true;
    gesteArme();
    if (capture && panneau && panneau.setPointerCapture) {
      try {
        panneau.setPointerCapture(idPointeur);
      } catch (e) {
        /* idem */
      }
    }
    return true;
  }

  function gPas(x, y, t, capture) {
    if (!gDecide(x, y, capture)) return false;
    var dd = coord(x, y) - d0;
    if (Math.abs(dd) > G_SLOP) bouge = true;
    echantillon(coord(x, y), t);
    gesteBouge(decalage(dd));
    return true;
  }

  function gFin(x, y, t, fermer) {
    if (!glisse) return;
    var etaitArme = arme;
    glisse = false;
    arme = false;
    try {
      if (idPointeur !== null && panneau && panneau.releasePointerCapture) {
        panneau.releasePointerCapture(idPointeur);
      }
    } catch (e) {
      /* deja relache */
    }
    idPointeur = null;
    gesteRepose();
    if (!etaitArme || !fermer) {
      trace.length = 0;
      return;
    }
    var dd = coord(x, y) - d0;
    var v = vitesse(coord(x, y), t);
    trace.length = 0;
    /* LA MEME PORTE QUE LA CROIX : `ferme()` sans argument, donc `depile()`,
       la restitution de l'adresse et le focus rendu au declencheur. */
    if (dd > 0 && (dd >= G_DISTANCE || Math.abs(v) > G_VELOCITY)) ferme();
  }

  function gAbandonne() {
    if (!glisse) return;
    glisse = false;
    arme = false;
    idPointeur = null;
    trace.length = 0;
    gesteRepose();
  }

  /* ── Le chemin du doigt ─────────────────────────────────────────────────
     Prioritaire sur celui du pointeur : c'est le seul qui peut dire non au
     defilement natif. `touchstart` en CAPTURE pour etre servi avant tout
     ecouteur de la page, `touchmove` NON PASSIF pour avoir le droit d'appeler
     `preventDefault()`.

     DEUX DOIGTS NE GLISSENT PAS UN TIROIR : c'est un pincement, et il
     appartient au navigateur (le zoom de page reste possible, regle
     d'accessibilite). */
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length > 1) { gAbandonne(); return; }
    var t = e.touches[0];
    gDebut(e.target, t.clientX, t.clientY, e.timeStamp, 'touch', false, 'touch');
  }, true);

  document.addEventListener('touchmove', function (e) {
    if (!glisse) return;
    if (e.touches.length > 1) { gAbandonne(); return; }
    var t = e.touches[0];
    if (!gPas(t.clientX, t.clientY, e.timeStamp, false)) return;
    /* C'est ICI, et nulle part ailleurs, que le defilement natif et le rebond
       elastique de WebKit sont arretes. */
    if (e.cancelable) e.preventDefault();
  }, { passive: false, capture: true });

  document.addEventListener('touchend', function (e) {
    if (!glisse) return;
    var t = e.changedTouches[0];
    gFin(t ? t.clientX : 0, t ? t.clientY : d0, e.timeStamp, true);
  }, true);

  document.addEventListener('touchcancel', gAbandonne, true);

  /* ── Le chemin du pointeur ──────────────────────────────────────────────
     Il reste pour le stylet. Quand le doigt a deja pris le geste en charge,
     `gDebut` rend `true` sans rien refaire et `gPas` est idempotent : les deux
     chemins ne peuvent pas deplacer le panneau deux fois.

     `pointercancel` NE DECIDE RIEN : une annulation de WebKit pourrait sinon
     fermer un tiroir que le visiteur n'a pas lache. */
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch' && glisse) return;
    gDebut(e.target, e.clientX, e.clientY, e.timeStamp, e.pointerId, true, e.pointerType);
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!glisse || e.pointerId !== idPointeur) return;
    gPas(e.clientX, e.clientY, e.timeStamp, true);
  });

  function gFinPointeur(e) {
    if (!glisse) return;
    gFin(e.clientX, e.clientY, e.timeStamp, e.type === 'pointerup');
  }

  document.addEventListener('pointerup', gFinPointeur);
  document.addEventListener('pointercancel', gFinPointeur);

  /* ── Branchements ──────────────────────────────────────────────────────── */
  var decl = document.querySelectorAll('.cm-guide-tiroir-trigger');
  for (var i = 0; i < decl.length; i++) {
    decl[i].setAttribute('aria-haspopup', 'dialog');
    decl[i].setAttribute('aria-controls', 'cm-guide-tiroir');
    decl[i].setAttribute('aria-expanded', 'false');
  }

  /* Delegation : le declencheur vit dans un composant qui peut se redessiner,
     l'ecouteur vit sur le document et survit a tout. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var d = e.target.closest('.cm-guide-tiroir-trigger');
    if (d) { e.preventDefault(); ouvre(d); return; }
    if (ouvert && e.target.closest('[data-cmg-fermer]')) {
      /* UN GLISSEMENT ANNULE NE DOIT PAS FERMER DEUX FOIS, NI FERMER TOUT
         COURT. Un glissement qui a ferme le tiroir ne laisse pas de `click`
         derriere lui ; un glissement ANNULE, lui, en laisse un, et le voile
         est justement une des trois zones qui arment le geste. Sans ce
         drapeau, un retour elastique parti du voile refermerait quand meme.
         Motif du panier (`casemira-cart.js`, lot I). */
      if (bouge && e.target.closest('.cmg-voile')) return;
      e.preventDefault();
      ferme();
    }
  });

  mesureLaBarre();
  /* L'unite accordee et l'etat des deux boutons sont poses des le chargement :
     Liquid a ecrit « 13 marches », le JS reprend la main sur la meme valeur et
     n'a donc rien a redessiner de visible. */
  if (CAS === 'escalier') ecritMarches(nMarches());
  calcule();
  }

  /* ── LANCEMENT ────────────────────────────────────────────────────────────
     Le tiroir des fiches, puis les hotes de la page guide. Les deux ne se
     rencontrent jamais : une fiche n'a pas d'hote de page, la page guide n'a
     pas de tiroir. */
  var tiroir = document.getElementById('cm-guide-tiroir');
  if (tiroir) demarre(tiroir, 'tiroir');

  var hotes = document.querySelectorAll('[data-cmg-page]');
  for (var iH = 0; iH < hotes.length; iH++) demarre(hotes[iH], 'page');
})();
